import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Btn from "../Btn/Btn";

export default function ShareButton({ data, className, children }) {
  const { t } = useTranslation('basic');
  const [status, setStatus] = useState(null);
  const canNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

  const payload = useMemo(() => {
    const title = data?.title ?? "";
    const text = data?.text ?? "";
    return {
      title,
      text,
      combined: [title, text].filter(Boolean).join("\n"),
    };
  }, [data]);

  const onShare = async () => {
    setStatus(null);

    try {
      if (canNativeShare) {
        await navigator.share({ title: payload.title, text: payload.text });
        setStatus("shared");
        return;
      }

      if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(payload.combined);
        setStatus("copied");
        return;
      }

      setStatus("unsupported");
    } catch (e) {
      setStatus("error");
    }
  };

  const label =
    status === "copied"
      ? t('share_copied')
      : status === "shared"
        ? t('share_shared')
        : (children ?? t('share_button'));

  return (
    <Btn
      fluid
      className={className}
      onClick={onShare}
      text={label}
      disabled={!payload.combined}
    />
  );
}

